/*
 * fixparser
 * https://gitlab.com/logotype/fixparser.git
 *
 * Copyright © 2022 fixparser.io
 * Released under Commercial license. Check LICENSE.md
 */
export enum MarketDepthEnum {
    FullBook = 0,
    TopofBook = 1,
    Best_2_PriceTiers = 2,
    Best_3_PriceTiers = 3,
    Best_4_PriceTiers = 4,
    Best_5_PriceTiers = 5,
    Best_6_PriceTiers = 6,
    Best_7_PriceTiers = 7,
    Best_8_PriceTiers = 8,
    Best_9_PriceTiers = 9,
    Best_10_PriceTiers = 10,
}
